import { EnumHelperBase, type EnumDataObject } from './enum.helpers';

export enum LANGUAGE {
	CZECH = 1,
	SLOVAK = 2,
	ENGLISH = 3,
	GERMAN = 4,
	FRENCH = 5,
	SPANISH = 6,
	RUSSIAN = 7,
	NORWEGIAN = 8,
	SWEDISH = 9,
}

export interface LanguageEnumBaseData extends EnumDataObject<LanguageEnumBaseExtraData, LANGUAGE, 'languageId'> {}

export interface LanguageEnumBaseExtraData {
	code: string;
}

/**
 * Base Language enumeration
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/global.png
 */
class LanguageEnumBase extends EnumHelperBase<LanguageEnumBaseExtraData, LANGUAGE, 'language', 'languageId'> {
	constructor() {
		super(
			'language',
			{
				[LANGUAGE.CZECH]: { code: 'cs' },
				[LANGUAGE.ENGLISH]: { code: 'en' },
				[LANGUAGE.SLOVAK]: { code: 'sk' },
				[LANGUAGE.GERMAN]: { code: 'de' },
				[LANGUAGE.FRENCH]: { code: 'fr' },
				[LANGUAGE.SPANISH]: { code: 'es' },
				[LANGUAGE.RUSSIAN]: { code: 'ru' },
				[LANGUAGE.NORWEGIAN]: { code: 'no' },
				[LANGUAGE.SWEDISH]: { code: 'sv' },
			},
			'languageId',
			null,
		);
	}
}

export const languageEnumBase = new LanguageEnumBase();
